import type { PluginWithOptions, Token } from "markdown-it"
import Renderer from "markdown-it/lib/renderer"
import * as StateInline from "markdown-it/lib/rules_inline/state_inline";

const openRe = /^-{3}\s*$/
const closeRe = /^(?:\.{3}|-{3})\s*$/

interface CustomEmojiOptions {
}

export const custom_ctrl_seq: PluginWithOptions<CustomEmojiOptions> = (md, options) => {
    md.inline.ruler.after('text','custom_ctrl_seq',(state: StateInline, silent: boolean) => {
        const pos = state.pos
        const max = state.posMax

        if (silent) return false;

        if (state.src.charCodeAt(pos) !== 0x000e /* SwitchIn */) return false

        const end = state.src.indexOf('\u000f', pos);
        if (end === -1 || end > state.posMax) return false;

        const [ctrl, ...args] = state.src.substring(state.pos+1, end).split('\u000e');

        if (ctrl === 'ICO') {
            const token = state.push('custom_emoji', 'miau-emoji', 1);
            token.attrs = [['src', args[0]]];
            state.push('custom_emoji_end', 'miau-emoji', -1);
        } else if (ctrl === 'LNK') {
            const token = state.push('custom_link', 'a', 1);
            token.attrs = [['href', 'meow:' + args[0]], ['class', 'custom_link']];
            if (args[2]) token.attrs.push(['target', args[2]]);
            const token2 = state.push('text', '', 0);
            token2.content = args[1] || args[0];
            state.push('custom_link_end', 'a', -1);
        } else {
            const token = state.push('unknown_ctrl', 'abbr', 1);
            token.attrs = [['style', 'background-color: green;padding: 0 2px;'], ['title', 'Unknown control sequence (args = '+args+')']]
            const token2 = state.push('text', '', 0);
            token2.content = ctrl;
            state.push('unknown_ctrl_end', 'abbr', -1);
        }
        state.pos = end + 1;
        return true;
    })
    function isTerminatorChar (ch) {
        switch (ch) {
            case 0x0E/* ShiftIn */:

            case 0x0A/* \n */:
            case 0x21/* ! */:
            case 0x23/* # */:
            case 0x24/* $ */:
            case 0x25/* % */:
            case 0x26/* & */:
            case 0x2A/* * */:
            case 0x2B/* + */:
            case 0x2D/* - */:
            case 0x3A/* : */:
            case 0x3C/* < */:
            case 0x3D/* = */:
            case 0x3E/* > */:
            case 0x40/* @ */:
            case 0x5B/* [ */:
            case 0x5C/* \ */:
            case 0x5D/* ] */:
            case 0x5E/* ^ */:
            case 0x5F/* _ */:
            case 0x60/* ` */:
            case 0x7B/* { */:
            case 0x7D/* } */:
            case 0x7E/* ~ */:
                return true
            default:
                return false
        }
    }

    function text (state, silent) {
        let pos = state.pos

        while (pos < state.posMax && !isTerminatorChar(state.src.charCodeAt(pos))) {
            pos++
        }

        if (pos === state.pos) { return false }

        if (!silent) { state.pending += state.src.slice(state.pos, pos) }

        state.pos = pos

        return true
    }
    md.inline.ruler.at('text', text);
}


export const custom_links: PluginWithOptions<CustomEmojiOptions> = (md, options) => {
    md.inline.ruler.after('text','custom_links',(state: StateInline, silent: boolean) => {
        const pos = state.pos
        const max = state.posMax

        if (silent) return false;

        if (state.src.charCodeAt(pos) !== 0x000e /* SwitchIn */) return false

        const end = state.src.indexOf('\u000f', pos);
        if (end === -1 || end > state.posMax) return false;

        const [ctrl, ...args] = state.src.substring(state.pos+1, end).split('\u000e');

        if (ctrl === 'ICO') {
            const token = state.push('custom_emoji', 'miau-emoji', 1);
            token.attrs = [['src', args[0]]];
            state.push('custom_emoji_end', 'miau-emoji', -1);
        } else if (ctrl === 'LNK') {
            const token = state.push('custom_link', 'a', 1);
            token.attrs = [['href', 'meow:' + args[0]], ['style', 'text-decoration: underline double;']];
            if (args[2]) token.attrs.push(['target', args[2]]);
            const token2 = state.push('text', '', 0);
            token2.content = args[1] || args[0];
            state.push('custom_link_end', 'a', -1);
        } else {
            const token = state.push('unknown_ctrl', 'abbr', 1);
            token.attrs = [['style', 'background-color: green;padding: 0 2px;'], ['title', 'Unknown control sequence (args = '+args+')']]
            const token2 = state.push('text', '', 0);
            token2.content = ctrl;
            state.push('unknown_ctrl_end', 'abbr', -1);
        }
        state.pos = end + 1;
        return true;
    })
}

